import styled from 'styled-components'

export const ContainerWaitingTime = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`

export const ContainerLoading = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
`

export const Image = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.theme.colors.primary.A100};
  width: 64px;
  height: 64px;
  border-radius: 50%;
  margin: 0 auto 24px;
`
